const PixelArt = ({ rows, color, px = 5, className = "" }: { rows: string[]; color: string; px?: number; className?: string }) => {
  const w = rows[0].length;
  const h = rows.length;
  return (
    <svg
      className={className}
      width={w * px}
      height={h * px}
      viewBox={`0 0 ${w} ${h}`}
      shapeRendering="crispEdges"
      aria-hidden="true"
    >
      {rows.flatMap((row, y) =>
        row.split("").map((c, x) =>
          c === "1" ? <rect key={`${x}-${y}`} x={x} y={y} width={1.02} height={1.02} fill={color} /> : null
        )
      )}
    </svg>
  );
};

const HEART = ["0110110", "1111111", "1111111", "0111110", "0011100", "0001000"];
const STAR = ["0001000", "0011100", "0111110", "1111111", "0111110", "0101010", "1000001"];
const BOLT = ["00110", "00110", "01100", "11110", "00110", "01100", "01000"];

interface StickerProps {
  color?: string;
  px?: number;
  className?: string;
}

export const PixelHeart = ({ color = "#FF5C8A", px = 5, className = "" }: StickerProps) => (
  <PixelArt rows={HEART} color={color} px={px} className={className} />
);

export const PixelStar = ({ color = "#F5C518", px = 5, className = "" }: StickerProps) => (
  <PixelArt rows={STAR} color={color} px={px} className={className} />
);

export const PixelBolt = ({ color = "#7C5CBF", px = 5, className = "" }: StickerProps) => (
  <PixelArt rows={BOLT} color={color} px={px} className={className} />
);
